import { ReactElement, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { isSandboxBlockedPath } from '@backrs_ui/grow-ui/src/appRoutes';
import { openSignupPrompt } from '@backrs_ui/grow-ui/src/redux/appState/appState';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { sandboxHomePath } from '@backrs_ui/grow-ui/src/utils/sandboxSession';

type SandboxRouteProps = Readonly<{
  children: ReactElement;
}>;

export const SandboxRoute = ({ children }: SandboxRouteProps) => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const isBlocked = isSandboxBlockedPath(location.pathname);

  useEffect(() => {
    if (isBlocked) {
      dispatch(openSignupPrompt('sandbox'));
    }
  }, [isBlocked, dispatch]);

  if (isBlocked) {
    return <Navigate to={sandboxHomePath()} replace />;
  }

  return children;
};
